import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userRequest } from "../api/requestMethods";

const initialState = {
  myOrders: [],
  isFetching: false,
  error: null,
  orderDetail: {},
};

// Get user's orders
export const fetchUserOrders = createAsyncThunk(
  "orders/fetchUserOrders",
  async (userId, { rejectWithValue }) => {
    try {
      // Validate userId before making request
      if (!userId || userId === 'undefined' || userId === 'null') {
        throw new Error('User ID is required. Please login again.');
      }

      const res = await userRequest.get(`/mobile/${userId}/myorders`);
      // console.log(res.data, "res from fetchUserOrders");
      return res.data;
    } catch (error) {
      console.error('Error fetching user orders:', error);
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch orders. Please try again.'
      );
    }
  }
);

// Get Order Details
export const fetchOrderDetails = createAsyncThunk(
  "orders/fetchOrderDetails",
  async (orderId) => {
    const res = await userRequest.get(`/weborders/${orderId}`);
    return res.data;
  }
);

const ordersSlice = createSlice({
  name: "myOrders",
  initialState,
  reducers: {
    ordersFetched: (state, action) => {
      state.myOrders = action.payload;
    },
    // Update a single order (used for real-time socket updates)
    updateOrder: (state, action) => {
      const updatedOrder = action.payload;
      const index = state.myOrders.findIndex(order => order._id === updatedOrder._id);
      if (index !== -1) {
        // Update existing order
        state.myOrders[index] = updatedOrder;
      }
      // Also update orderDetail if it matches
      if (state.orderDetail?._id === updatedOrder._id) {
        state.orderDetail = updatedOrder;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserOrders.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
        state.myOrders = action.payload;
        state.isFetching = false;
        state.error = false;
      })
      .addCase(fetchUserOrders.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch orders';
        state.isFetching = false;
        state.myOrders = [];
      })
      .addCase(fetchOrderDetails.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.orderDetail = action.payload;
        state.isFetching = false;
        state.error = false;
      })
      .addCase(fetchOrderDetails.rejected, (state) => {
        state.error = true;
        state.isFetching = false;
      });
  },
});
export const { ordersFetched, updateOrder } = ordersSlice.actions;
export default ordersSlice.reducer;
